import { externalDashboardsRoutes } from './external-dashboards.routing'
import { ExternalDashboardsComponent } from './external-dashboards.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from 'src/app/shared/shared.module'

@NgModule({
  declarations: [ExternalDashboardsComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(externalDashboardsRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
  ],
  exports: [ExternalDashboardsComponent],
})
export class ExternalDashboardsModule {}
